import React from 'react';
import Field from '@cpg-its/ads.form.field';
import { makeStyles } from '@material-ui/core';
import { helveticaBold, helveticaRoman } from '../../constants/theme/theme-constants/typograhy-overrides';

const useStyles = makeStyles({
    autoWidth: {
        display: 'inline-block',
        '& .MuiInputBase-root': {
            width: '10rem',
        },
        '& .MuiFormLabel-root': {
            '& > div': {
                marginLeft: '2rem',
            },
        },
    },
    overrides: {
        '& .MuiOutlinedInput-adornedEnd': {
            paddingRight: '0',
            '& .MuiOutlinedInput-notchedOutline': {
                border: 'none',
            },
        }, // date picker overrides
        '& .MuiFormLabel-root': {
            '& span': {
                fontFamily: helveticaBold,
            },
        },
        '& .MuiFormControlLabel-root': {
            alignItems: 'flex-start',

            '& .MuiCheckbox-root': {
                width: '20px',
                height: '20px',
            },
            '& .MuiRadio-root': {
                marginTop: '0',
                '& + .MuiFormControlLabel-label': { // label overrides for Radio buttons
                    '& > div': {
                        marginTop: '0',
                    },
                },
            },
            '& .MuiTypography-root.extraBold': {
                fontFamily: helveticaRoman,
                fontWeight: 400,
            },
        },

    },
});

export function FormField(props: any) {
    const classes = useStyles();


    return (
        <div className='form-item'>
            <div className={`${classes.overrides} ${props.autoWidth ? classes.autoWidth : ''}`}>
                <Field {...props} />
            </div>
        </div>
    );
}


